"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TodoListElement = void 0;
var _react = _interopRequireDefault(require("react"));
var _cn = require("@udecode/cn");
var _plateCommon = require("@udecode/plate-common");
var _checkbox = require("./checkbox");
var _useTodoListElement = require("../hooks/useTodoListElement");
var _jsxRuntime = require("react/jsx-runtime");
var TodoListElement = exports.TodoListElement = (0, _cn.withRef)(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, ["children", "className"]);
  var element = props.element;
  var state = (0, _useTodoListElement.useTodoListElementState)({
    element: element
  });
  var _ref2 = (0, _useTodoListElement.useTodoListElement)(state),
    checkboxProps = _ref2.checkboxProps;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_plateCommon.PlateElement, _objectSpread({
    className: (0, _cn.cn)('flex flex-row py-1', className),
    ref: ref
  }, props, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "mr-1.5 flex select-none items-center justify-center",
      contentEditable: false,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_checkbox.Checkbox, _objectSpread({}, checkboxProps))
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: (0, _cn.cn)('flex-1 focus:outline-none', state.checked && 'text-muted-foreground line-through'),
      contentEditable: !state.readOnly,
      suppressContentEditableWarning: true,
      children: children
    })]
  }));
});